import UploadImage from './UploadImage'
export * from './UploadImage'

export default UploadImage
